export const BUSINESS_DETAILS_ROUTE = '/business-details';
export const SELECT_COVER_ROUTE = '/select-cover';
export const COVER_DETAILS_ROUTE = '/cover-details';
export const COVER_DETAILS_LIABILITY_ROUTE = '/cover-details/liability';
export const COVER_DETAILS_BUILDING_AND_CONTENTS_ROUTE = '/cover-details/building-and-contents';
export const COVER_DETAILS_BUSINESS_INTERRUPTION_ROUTE = '/cover-details/business-interruption';
export const COVER_DETAILS_PORTABLE_ITEMS_ROUTE = '/cover-details/portable-items';
export const COVER_DETAILS_THEFT_ROUTE = '/cover-details/theft';
export const COVER_DETAILS_MONEY_ROUTE = '/cover-details/money';
export const COVER_DETAILS_GLASS_ROUTE = '/cover-details/glass';
export const COVER_DETAILS_BREAKDOWN_ROUTE = '/cover-details/breakdown';
export const COVER_DETAILS_TAX_AUDIT_ROUTE = '/cover-details/tax-audit';
export const MEMBERSHIP_ROUTE = '/membership';
export const QUOTE_ROUTE = '/quote';
export const EXTRA_INFO_ROUTE = '/extra-info';
export const EXTRA_INFO_CUSTOMER_HISTORY_ROUTE = '/extra-info/customer-history';
export const EXTRA_INFO_MORE_BUSINESS_DETAILS_ROUTE = '/extra-info/more-business-details';
export const REVIEW_ROUTE = '/review';
export const PAYMENTS_ROUTE = '/payments';
export const CONFIRMATION_ROUTE = '/confirmation';
export const RETRIEVE_QUOTE_ROUTE = '/retrieve-quote';
export const PAY_MY_BILL_ROUTE = '/pay-my-bill';
export const PAY_MY_BILL_CONFIRMATION_ROUTE = '/pay-my-bill/confirmation';

export const STAFF_ROUTE = '/staff';
